import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../services/api';

const Ctx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadUser = useCallback(async () => {
    const token = localStorage.getItem('trd_token');
    if (!token) { setLoading(false); return; }
    try {
      const { data } = await api.get('/auth/me');
      setUser(data);
    } catch { localStorage.clear(); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { loadUser(); }, [loadUser]);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    localStorage.setItem('trd_token', data.token);
    await loadUser();
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post('/auth/register', payload);
    localStorage.setItem('trd_token', data.token);
    await loadUser();
    return data;
  };

  const completeLinkedIn = useCallback(async (code) => {
    const { data } = await api.post('/auth/linkedin/exchange', { code });
    localStorage.setItem('trd_token', data.token);
    await loadUser();
    return data;
  }, [loadUser]);

  const logout = () => { localStorage.clear(); setUser(null); };
  const refresh = () => loadUser();

  return (
    <Ctx.Provider value={{ user, login, register, completeLinkedIn, logout, refresh, loading }}>
      {children}
    </Ctx.Provider>
  );
};

export const useAuth = () => useContext(Ctx);
